import React, {useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import Styles from "./About.module.scss"
import {Header, Title, Breadcrumbs, Switcher} from "../../components";
import {AboutPropsType} from "./types";
import {useCurrentWidth} from "../../hooks";
import {MediaBreakPoints} from "../../resources/constants";

export const About: React.FC<AboutPropsType> = ({title}) => {
    const navigate = useNavigate();
    const windowWidth = useCurrentWidth();
    const breakPoint = MediaBreakPoints.MOBILE_LARGE;
    const [activePage, setActivePage] = useState("");
    const [titleMobile, setTitle] = useState('О клубе');

    const handleNavigate = (route: string) => {
        setActivePage(route);
        navigate(route);
    };
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        if(windowWidth >= breakPoint && location.pathname === "/about"){
            navigate("clubFoto")
            setActivePage("clubFoto")
        }
        else if(location.pathname === "/about/clubFoto"){
            setActivePage("clubFoto")
        }
        else if(location.pathname === "/about/hallsFoto"){
            setActivePage("hallsFoto")
        }
    }, [windowWidth, location.pathname, navigate, breakPoint])

    return (
        <>
            <main>
                {
                    windowWidth > breakPoint ? (
                        <Header title={title} />
                    ) : (
                        <Header title={titleMobile} />
                    )
                }
                <div className="container">
                    <Breadcrumbs />
                </div>
                <section className="container">
                    <Title>{title}</Title>
                    <Switcher
                        options={[
                            { value: "clubFoto", label: "Клуб" },
                            { value: "hallsFoto", label: "Спортивные залы" },
                        ]}
                        activeValue={activePage}
                        onChange={handleNavigate}
                    />
                    <div className={Styles.wrapper}>
                        <Outlet/>
                    </div>
                </section>
            </main>
        </>
    );
};

